import React, { useState } from "react";
import { Col, Row, Form, Select, Button } from "antd";
import { OPTIONAL_VALUES } from '@frontend/constants/initialValues'
import QuestionFields from "./QuestionFields";
//import { add, remove } from "@frontend/helpers/formList.helper"
const name = "question_attributes"

const template = {
    id: null,
    input_type : null,
    is_video: false,
    question: "",
    required: false,
    selection_process_options: []
  }

const QuestionsForm = ({form, initValues={income: false, experience: false, disability: false, questions: []}, readonly=false}) => {

    const [id, setId] = useState(initValues.questions.length)
    const [questions, setQuestions] = useState(initValues.questions)
    const add = () => {
        const keys = form.getFieldValue(name);
        const nextKeys = keys.concat(id);
        setId(id+1)
        form.setFieldsValue({
        [name]: nextKeys,
        });
    }

    const remove = (k,identifier) => {
        const keys = form.getFieldValue(name);
        if(identifier)
            setQuestions(questions.splice(k,1))
        form.setFieldsValue({
        [name]: keys.filter(key => key !== k),
        });
    }

    const { getFieldDecorator } = form
    const fields = form.getFieldValue(name) || [...Array(questions?.length).keys()]

    form.getFieldDecorator(name , { initialValue: [...Array(questions?.length).keys()] })

    return(
        <>
            <Row gutter={{xs:0, sm: 32}}>
                <Col sm={{ span: 8 }} xs={{ span: 24}}>
                    <Form.Item
                        label="¿Cuáles son sus expectativas de Renta?"
                    >
                        {getFieldDecorator("income_expectation_active", {initialValue: initValues?.income})(
                            <Select
                                style={{ width: "100%" }}
                                optionLabelProp="label"
                                placeholder="Selecciona una opción"
                                disabled={readonly == true}
                                >
                                {OPTIONAL_VALUES.map((item) => (
                                    <Select.Option key={item.value} value={item.value} label={`${item.name}` || ""}>{item.name}</Select.Option>
                                ))}
                            </Select>
                        )}
                    </Form.Item>
                </Col>
                <Col sm={{ span: 8 }} xs={{ span: 24}}>
                    <Form.Item
                        label="¿Cuántos años de experiencia posee para este cargo?"
                    >
                        {getFieldDecorator("experience_active", {initialValue: initValues?.experience})(
                            <Select
                                style={{ width: "100%" }}
                                optionLabelProp="label"
                                placeholder="Selecciona una opción"
                                disabled={readonly == true}
                                >
                                {OPTIONAL_VALUES.map((item) => (
                                    <Select.Option key={item.value} value={item.value} label={`${item.name}` || ""}>{item.name}</Select.Option>
                                ))}
                            </Select>
                        )}
                    </Form.Item>
                </Col>
                <Col sm={{ span: 8 }} xs={{ span: 24}}>
                    <Form.Item
                        label="¿Posees alguna discapacidad?"
                    >
                        {getFieldDecorator("disability_active", {initialValue: initValues?.disability})(
                            <Select
                                style={{ width: "100%" }}
                                optionLabelProp="label"
                                placeholder="Selecciona una opción"
                                disabled={readonly == true}
                                >
                                {OPTIONAL_VALUES.map((item) => (
                                    <Select.Option key={item.value} value={item.value} label={`${item.name}` || ""}>{item.name}</Select.Option>
                                ))}
                            </Select>
                        )}
                    </Form.Item>
                </Col>
            </Row>
            <h5 className="question_form_title"> Preguntas Personalizadas </h5>
            {fields.map((value, index) => (
                <div key={index}>
                    <QuestionFields
                        form={form}
                        id={value}
                        initialValues={questions?.length>value ? initValues.questions[value] : template }
                        remove={() => remove(value)}
                    />
                </div>
            ))}
            <Form.Item>
                <Button className="custom-button-postulation" onClick={()=>add()} block disabled={readonly == true}>
                + Agregar nueva pregunta
                </Button>
            </Form.Item>

        </>
    )
}

export default QuestionsForm
